import React from 'react'
import {  Button } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { OPEN_DIALOG } from '../redux/dialogReducer'
import { CLOSE_ALERT } from '../redux/alertReducer'
import AssignAdminToAcsDffEntitlementDialog from './dialog/assignAdminToAcsDffEntitlement'

const AssignAdminToAcsDffEntitlementButton = ({
  targetEntitlement,
  setNeedsFetchData,
}) => {
  const dispatch = useDispatch()

  return <Button
      variant="contained"
      size="small"
      color="primary"
      onClick={() => {
        dispatch({
          type: OPEN_DIALOG,
          component: AssignAdminToAcsDffEntitlementDialog,
          props: {
            targetEntitlement,
            setNeedsFetchData,
          },
        })
        dispatch({
          type: CLOSE_ALERT,
        })
      }}
    >
      Assign admin to Entitlement
    </Button>
  
}

export default AssignAdminToAcsDffEntitlementButton
